import { render } from "./TextLink.vue?vue&type=template&id=7ae70d1c&ts=true"
import script from "./TextLink.vue?vue&type=script&lang=ts"
export * from "./TextLink.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__